'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var react = require('@chakra-ui/react');
var reactUtils = require('@chakra-ui/react-utils');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["spacingBottom", "spacingLeft", "imageWidth", "isOverflowing"];

// Note: We make our own context here because otherwise, they clash with the Card's contexts.
var _createContext = reactUtils.createContext({
    name: 'StylesContext',
    errorMessage: 'useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` '
  }),
  _createContext2 = _slicedToArray__default["default"](_createContext, 2),
  StylesProvider = _createContext2[0],
  useStyles = _createContext2[1];
/**
 * Card column wrapper
 *
 * Helps to define (overflowing) image and content columns inside various cards
 *
 * @internal Used internally by [Anything]Card components.
 */
var CardColumnWrapper = react.forwardRef(function (originalProps, ref) {
  originalProps.spacingBottom;
  originalProps.spacingLeft;
  originalProps.imageWidth;
  originalProps.isOverflowing;
  var rest = _objectWithoutProperties__default["default"](originalProps, _excluded);
  var styles = react.useMultiStyleConfig('CardColumnWrapper', originalProps);
  return /*#__PURE__*/React__default["default"].createElement(StylesProvider, {
    value: styles
  }, /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    ref: ref
  }, rest, {
    __css: styles.container
  })));
});
CardColumnWrapper.displayName = 'CardColumnWrapper';
exports.CardColumnWrapper = CardColumnWrapper;
exports.StylesProvider = StylesProvider;
exports.useStyles = useStyles;